import styled from 'styled-components';

export const InterviewTextRight = styled.div`
  margin-top: 5em;

  p {
    font-size: 0.9em;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    display: inline-block;
    margin-top: 1em;

    &:first-child {
      margin-top: 0;
    }
  }
  .block {
    display: block;
  }

  .inline {
    display: inline;
  }
  /*   .none {
    display: unset;
  } */

  .inline-block {
    display: inline-block;
  }

  .title-margin {
    margin: 1em 0 0;
  }

  .paddingBottom {
    padding-bottom: 4em;
  }

  .image-block-height {
    height: unset;
  }

  .image-block-height-ver-2 {
    height: unset;
  }
  .image-block-height-ver-3 {
    height: unset;
  }

  /*   h2 #stefan {
    display: unset;
  } */

  @media all and (min-width: 960px) {
    .Line {
      padding-top: 15px;
    }
    /*     .Kathrine {
      padding-top: 0px;
    } */
    .paddingTop {
      padding-top: 2em;
    }
    .image-block-height {
      height: 400px;
    }
    .image-block-height-ver-2 {
      height: 420px;
    }
    .image-block-height-ver-3 {
      height: 475px;
    }
  }

  .inline-image {
    width: 100%;
    margin-bottom: 2em;
    object-fit: contain;

    @media all and (min-width: 960px) {
      margin-top: 0;
      margin-right: 2em;
      max-width: 45%;
      float: left;
    }
  }

  .inline-image-ver-2 {
    width: 100%;
    margin-bottom: 2em;
    object-fit: contain;

    @media all and (min-width: 1085px) {
      width: 100%;
      margin-top: 0;
      margin-right: 2em;
      max-width: 45%;
      float: left;
    }
  }
`;
